<template>
	<core-layout-content full>
		<!-- Headline -->
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("dashboard") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<div>
			<!-- Demo Note -->
			<div
				v-if="$store.state.settings.devFlags.hasDemoNote"
				class="xs-12 bgWarning--l4 b2 bcWarning c1 p4 r2 mb2"
			>
				<div class="xs-12 fs4 fw7 lh125 mb1">{{ $t("demo_disclaimer_headline") }}</div>
				<div class="lh125">{{ $t("demo_disclaimer_text") }}</div>
			</div>

			<!-- Quick Stats -->
			<div class="flex wrap xs-12">
				<!-- Clients -->
				<dashboard-quick-stats
					:count="numberOfClients"
					:title="`${$t('clients')}`"
					v-if="settings.dashboard.detail.hasNumberOfClients"
				>
					<template slot="bottom" v-can:or="['writeIndividuals', 'writeCompanies']">
						<j-button type="primary" :to="`/${$store.state.tenantId}/clients/create`">
							<crm-icon color="c5" name="clients" size="small" class="mr1" />
							{{ $t("create_new_client") }}
						</j-button>
					</template>
				</dashboard-quick-stats>

				<!-- Policies -->
				<dashboard-quick-stats
					:count="numberOfPolicies"
					:title="`${$t('policies')}`"
					v-if="settings.dashboard.detail.hasNumberOfPolicies"
				>
					<template slot="bottom" v-can:or="['writeIndividuals', 'writeCompanies']">
						<j-button
							v-if="
								$store.state.settings.policies.creating.hasApiCreation ||
									$store.state.settings.policies.creating.hasManualCreation
							"
							type="primary"
							:to="createNewPolicy"
						>
							<crm-icon color="c5" name="policies" size="small" class="mr1" />
							{{ $t("create_new_policy") }}
						</j-button>
						<j-button
							v-else
							type="primary"
							:to="`/${$route.params.tenantId}/policies`"
						>
							<crm-icon color="c5" name="policies" size="small" class="mr1" />
							{{ $t("view_all_policies") }}
						</j-button>
					</template>
				</dashboard-quick-stats>

				<!-- Quotes -->
				<dashboard-quick-stats
					:count="numberOfQuotes"
					:title="`${$t('quotes')}`"
					v-if="settings.dashboard.detail.hasNumberOfQuotes"
				>
					<template slot="bottom">
						<j-button type="primary" :to="`/${$store.state.tenantId}/quotes/create`">
							<crm-icon color="c5" name="quotes" size="small" class="mr1" />
							{{ $t("create_new_quote") }}
						</j-button>
					</template>
				</dashboard-quick-stats>

				<!-- Cases -->
				<dashboard-quick-stats
					:count="numberOfCases"
					:title="`${$t('cases')}`"
					v-if="settings.dashboard.detail.hasNumberOfCases"
				>
					<template slot="bottom" v-can="'writeCases'">
						<j-button
							v-if="
								$store.state.settings.policies.creating.hasApiCreation ||
									$store.state.settings.policies.creating.hasManualCreation
							"
							type="primary"
							:to="createNewCase"
						>
							<crm-icon color="c5" name="policies" size="small" class="mr1" />
							{{ $t("create_new_case") }}
						</j-button>
						<j-button
							v-else
							type="primary"
							:to="`/${$route.params.tenantId}/case-management`"
						>
							<crm-icon color="c5" name="policies" size="small" class="mr1" />
							{{ $t("view_all_cases") }}
						</j-button>
					</template>
				</dashboard-quick-stats>
			</div>

			<!-- Chart -->
			<div class="xs-12 mt4" v-if="settings.dashboard.detail.hasGraph">
				<dashboard-chart />
			</div>
		</div>
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import JAvatar from "@/components/JAvatar"
import DashboardChart from "../components/DashboardChart"
import DashboardQuickStats from "../components/DashboardQuickStats"
import api from "../api/"
import dayjs from "dayjs"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		DashboardChart,
		DashboardQuickStats,
		CrmIcon,
		JCard,
		JButton,
		JAvatar
	},

	data() {
		return {
			numberOfClients: "-",
			numberOfPolicies: "-",
			numberOfQuotes: "-",
			numberOfCases: "-"
		}
	},

	methods: {
		async readTotalCounts() {
			const res = await api.readTotalCounts()

			// Map Data
			this.numberOfClients =
				res.data.individuals.totalCount + res.data.companies.totalCount
			this.numberOfPolicies = res.data.policies.totalCount
			this.numberOfQuotes = res.data.quotes.totalCount
			this.numberOfCases = res.data.cases.totalCount
		}
	},

	computed: {
		settings() {
			return this.$store.state.settings
		},

		createNewPolicy() {
			if (this.$store.state.tenantId === "asia_uat") {
				return `/${this.$store.state.tenantId}/quotes/create`
			} else if (
				["aeg_uat", "aeg", "berkley", "berkley_uat"].includes(
					this.$store.state.tenantId
				)
			) {
				return `/${this.$store.state.tenantId}/case-management`
			} else
				return `/${this.$store.state.tenantId}/policies/create-policy-crossroads`
		},

		createNewCase() {
			return `/${this.$store.state.tenantId}/case-management/create`
		}
	},

	async created() {
		await this.readTotalCounts()
	}
}
</script>
